import { isCrossOrganizationTarget, rolloutApiClient, staffRolloutPath, type RolloutTarget } from './rollout_target'

export type MissionStackRolloutLevel = 'off' | 'authoring' | 'execution'

export interface MissionStackRolloutPolicy {
  organizationId: string
  level: MissionStackRolloutLevel
  revision: number
  /**
   * Set by the staff route (PLAN-20260930 slice 5): true when the server
   * refuses a staff change of this card in this environment. The
   * organisation's own route does not send it.
   */
  environmentLocked?: boolean
}

export interface MissionStackRolloutHistoryEntry {
  organizationId: string
  revision: number
  previousLevel: MissionStackRolloutLevel
  level: MissionStackRolloutLevel
  actorId: string
  reason: string
  changedAt: string
}

interface MissionStackRolloutHistoryResponse {
  history: MissionStackRolloutHistoryEntry[]
}

export interface ChangeMissionStackRolloutPolicy {
  expectedRevision: number
  level: MissionStackRolloutLevel
  reason: string
  confirmed: true
}

function policyPath(target?: RolloutTarget): string {
  return isCrossOrganizationTarget(target) ? staffRolloutPath('mission-stack', target.organizationId) : 'mission-stack-rollout'
}

function historyPath(target?: RolloutTarget): string {
  return isCrossOrganizationTarget(target)
    ? staffRolloutPath('mission-stack', target.organizationId, 'history')
    : 'mission-stack-rollout/history'
}

export function getMissionStackRolloutPolicy(target?: RolloutTarget): Promise<MissionStackRolloutPolicy> {
  return rolloutApiClient(target).get<MissionStackRolloutPolicy>(policyPath(target))
}

export async function listMissionStackRolloutHistory(target?: RolloutTarget): Promise<MissionStackRolloutHistoryEntry[]> {
  const response = await rolloutApiClient(target).get<MissionStackRolloutHistoryResponse>(historyPath(target))
  return response.history ?? []
}

export function changeMissionStackRolloutPolicy(
  command: ChangeMissionStackRolloutPolicy,
  target?: RolloutTarget,
): Promise<MissionStackRolloutPolicy> {
  return rolloutApiClient(target).put<MissionStackRolloutPolicy, ChangeMissionStackRolloutPolicy>(policyPath(target), command)
}
